/**
 * Single `process.env` reference for the browser bundle.
 * CRA DefinePlugin replaces this with one inlined env object — do not spread `process.env.REACT_APP_*`
 * across many files (that duplicates the object per module).
 *
 * Note: Any `REACT_APP_*` variable **set on the machine when `npm run build` runs** is included in
 * that object. To keep DSP key / appload JWT **out** of the bundle, unset them for production
 * builds and set `window.__DSP_API_KEY__` and `window.__SPOTLIGHT_EMBEDDED_JWT__` before the app
 * script (see `runtimePublicEnv.js` and `index.js`).
 */
export const clientEnv = process.env;
